module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Chaise.7d456bf6.jpg";